import * as React from 'react';
import { Route } from 'react-router-dom';
import { RenderDocument } from './components/RenderDocument';

export const routes = <Route path='/*' component={RenderDocument} />;



// WEBPACK FOOTER //
// ./ClientApp/routes.tsx